module.exports = __webpack_public_path__ + "static/checkatrade-384f610de387ab4ebb5e80144a4a59ff.jpg";